// extracted by mini-css-extract-plugin
module.exports = {"cls1":"styles-PaddingBlock-module--cls1--1UZFQ","cls2":"styles-PaddingBlock-module--cls2--1dxwq styles-PaddingBlock-module--cls1--1UZFQ"};